import data from './data'
import {isUndefined} from 'lodash'
import React from 'react'
import {isNull, isEmpty} from 'lodash'
import WidgetFilter from '../PopUps/WidgetFilter'
import IntlMessages from 'util/IntlMessages';
export default function Widgets(props) {
  const [Component, setComponent] = React.useState(null)
  const [filterArr, setFilterArr] = React.useState([])

  React.useEffect(() => {
    setComponent(GetComponent(props))
  },[props, filterArr])

  const GetComponent = (props) => {
		console.log(props, data, 'dddddddd')
    let item = data.find(d => d.type === props.type)
    if(isUndefined(item)) return <><IntlMessages id="Invalid.type"/></>
    return (<>
      {
        !isEmpty(item.filter) && 
        <div style={{position: 'absolute', left:0, top: 0, zIndex:100}} className="d-flex align-items-center">
          <WidgetFilter filterArr={filterArr} setFilterArr={setFilterArr}  filterOptions={item.filter} {...props}/>
        </div>
      }
      <item.Component {...props} filterOptionsArr={filterArr}/>
    </>)
  }

  return <>{!isNull(Component) && Component}</>
}
